import BaseEntity from './BaseEntity';
export default class Digest extends BaseEntity {
    constructor(digest) {
        super();
        this.lines = null;
        this.branches = null;
        this.functions = null;
        this.max = null;
        this.avg = null;
        this.lines = this.parseProperty(digest, 'lines');
        this.branches = this.parseProperty(digest, 'branches');
        this.functions = this.parseProperty(digest, 'functions');
        this.max = this.parseProperty(digest, 'max');
        this.avg = this.parseProperty(digest, 'avg');
        this.fnf = this.parseProperty(digest, 'fnf');
        this.fnh = this.parseProperty(digest, 'fnh');
        this.lf = this.parseProperty(digest, 'lf');
        this.lh = this.parseProperty(digest, 'lh');
        this.brf = this.parseProperty(digest, 'brf');
        this.brh = this.parseProperty(digest, 'brh');
    }
    getAvg() {
        // eslint-disable-next-line no-undefined
        return this.avg ?? undefined;
    }
    getBranches() {
        // eslint-disable-next-line no-undefined
        return this.branches ?? undefined;
    }
    getFunctions() {
        // eslint-disable-next-line no-undefined
        return this.functions ?? undefined;
    }
    getLines() {
        // eslint-disable-next-line no-undefined
        return this.lines ?? undefined;
    }
    getMax() {
        // eslint-disable-next-line no-undefined
        return this.max ?? undefined;
    }
}
